export default "__VITE_ASSET__e7VpbA67__"